import shopifyImage from "assets/images/website_demo.png";
import vitsellImage from "assets/images/Vitsell.png";
import digiImage from "assets/images/Digi Vitsell.png";

export const initialShopState = {
  s1: [
    "پنل مدیریتی کاربرپسند (User Friendly) و پیشرفته",
    "بهینه سازی شده برای موتورهای جستجو (SEO Friendly)",
    "تم های متعدد فروشگاهی و کاملاً واکنشگرا (Responsive)",
    "قابل اتصال به سیستم ها و سرویس های دیگر",
    "بدون هیچگونه محدودیت در تعداد کالا، دسته بندی، تخفیف، کاربر، قیمت ،نقش کابران، تعیین سطوح دسترسی و ...",
    "سیستم ماژولار و قابل توسعه با پشتیبانی تخصصی به همراه ارائه خدمات حوضه تجارت الکترونیک",
  ],
  s2: [
    {
      title: "تم ویتسل",
      price: 18000000,
      image: vitsellImage,
      icon: "",
      link: "https://vitsell.ir",
      appLink: "https://cafebazaar.ir/app/com.vistaapp",
    },
    {
      title: "تم شاپیفای",
      price: 18000000,
      image: shopifyImage,
      icon: "",
      link: "https://shopify.vitsell.ir",
      appLink: "https://www.chortke.app/application/app-debug.apk",
    },
    {
      title: "تم دیجی",
      price: 18000000,
      image: digiImage,
      icon: "",
      link: "https://digi.vitsell.ir",
      appLink: "https://cafebazaar.ir/app/com.vistaapp",
    },
  ],
  activeTheme: 0,
  s3: [
    {
      title: "اپلیکیشن اندروید و IOS",
      subTitle:
        "اپلیکیشن اندروید و ios به صورت کاملا همگام با فروشگاه بوده و قابل عرضه بر روی تمامی استورهای اپلیکیشن خواهد بود",
      price: 14300000,
      active: false,
    },
    {
      title: "سامانه پیامکی",
      subTitle:
        "سامانه پبامکی فروشگاه اینترنتی چرتکه این امکان را به کاربر میدهد که در شرایط مختلف برای مشتریان خود کد های تخفیف، وضعیت سفارش، اعلام جشنواره ها و... را اطلاع دهد",
      price: 3400000,
      active: false,
    },
    {
      title: "افزونه آمار",
      subTitle:
        "افزونه آمار اطلاعات کاملی از تعداد مشتریان، رنج سنی و میزان ترافیک وارد شده به سایت و اطلاعات کمپین های اجرا شده بر روی وبسایت، کلیدواژه های برتر جستجو شده، تعداد مخاطب از شهر های مختلف و... را میدهد",
      price: 2600000,
      active: false,
    },
    {
      title: "اتصال به پیک",
      subTitle:
        "با این ماژول امکان ارسال مرسولات شما به صورت کاملا اتوماتیک از طریق اتصال سامانه فروشگاهی چرتکه به سامانه پست، تیپاکس و... را میدهد",
      price: 4200000,
      active: false,
    },
    {
      title: "حسابداری",
      subTitle:
        "با اتصال نرم افزار فروشگاهی چرتکه به حسابداری چرتکه تمامی مشتریان، فاکتور ها، محصولات، موجودی انبار های شما به صورت کامل با هم هماهنگ شده و تجربه عالی یک نرم افزار یکپارچه را به دست خواهید آورد",
      price: 2400000,
      active: false,
    },
    {
      title: "چند زبانه",
      subTitle: "با این ماژول پلتفرم فروشگاهی شما علاوه بر زبان فارسی از زبان های دیگر پشتیبانی خواهد کرد",
      price: 6800000,
      active: false,
    },
    {
      title: "چند فروشندگی",
      subTitle:
        "با ماژول چند فروشندگی علاوه بر خودتان افراد دیگر نیز میتوانند در فروشگاه اینترنتی شما به عنوان فروشنده فعالیت کنند و درصدی از فروششان به شما تعلق خواهد گرفت",
      price: 18900000,
      active: false,
    },
    {
      title: "تیکتینگ",
      subTitle: "پشتیبانی مشتریان از طریق ثبت تیکت + قابلیت ایجاد فرم های متعدد",
      price: 5300000,
      active: false,
    },
    {
      title: "قیمت پیشرفته",
      subTitle:
        "با وجود این امکان شما میتوانید به راحتی قیمت محصولات خود را به صورت گروهی بر اساس عدد ثابت یا درصد افزایش یا کاهش دهید",
      price: 2500000,
      active: false,
    },
  ],

  s4: [
    "در صورتیکه امکانات مورد نیاز کسب و کار شما در میان ماژول های فروشگاه اینترنتی چرتکه وجود ندارد و یا اینکه اجرای ایده شما در زمینه ساخت سایت فروشگاهی اختصاصیتان به امکانات بیشتری نسبت به امکانات موجود در سیستم فعلی فروشگاه اینترنتی چرتکه نیاز دارد، میتوانید با ارسال RFP برای واحد فروش، پروپوزال دریافت کنید.",
  ],
};
